export const RESOURCES = '[RESOURCES]'
export const INCREASE_RESOURCES = `${RESOURCES} Increase amount of resources`
export const INIT_RESOURCES = `${RESOURCES} Set initial amount of resources`

export const initialiseResources = resources => ({
    type: INIT_RESOURCES,
    payload: {
        resources,
    },
    meta: {
        persisted: 'resources',
    },
})

export const addToResources = resources => ({
    type: INCREASE_RESOURCES,
    payload: {
        resources,
    },
    meta: {
        persisted: 'resources',
    },
})
